module.exports = __webpack_public_path__ + "img/xl_pdk.4d826175.png";